import React from 'react'
import { Link } from 'react-router-dom'
import { useCms } from '../context/CmsContext'

export default function Footer() {
  const { siteSettings, tattooStyles } = useCms()
  const currentYear = new Date().getFullYear()

  const footerBgUrl = "https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/b7bd9965-d19c-45c5-aaa1-9572b70fbe0d/docuit-footer-dark-studio-bg.png"

  return (
    <footer className="relative bg-[#0b0c0e] border-t border-[#282b34] text-neutral-300 pt-16 pb-12 overflow-hidden">
      {/* Background Image with Dark Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-45 pointer-events-none mix-blend-luminosity"
        style={{ backgroundImage: `url(${footerBgUrl})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0b0c0e] via-[#0b0c0e]/70 to-[#0b0c0e]/90 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-neutral-800/80">
          
          {/* Col 1: Brand Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <div className="relative w-20 h-20 sm:w-28 sm:h-28 rounded-full overflow-hidden border border-[#cbb05e]/50 p-1 bg-[#17191e] transition-transform duration-300 group-hover:scale-105 shadow-lg">
                <img
                  src={siteSettings.logo}
                  alt="Docuit ink logo"
                  className="w-full h-full object-contain rounded-full"
                />
              </div>
            </Link>
            <div className="pt-2">
              <a
                href={siteSettings.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3.5 py-2 bg-neutral-900 border border-white/30 hover:border-white text-xs font-semibold text-white rounded-full transition-colors"
              >
                <i className="fa-brands fa-facebook text-base text-white" aria-hidden="true" />
                Følg os på Facebook
              </a>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-white font-bold mb-4">
              Navigation
            </h4>
            <ul className="space-y-2.5 text-xs">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/tatoveringer" className="hover:text-white transition-colors">
                  Tatoveringer
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-white transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/om-docuit-ink" className="hover:text-white transition-colors">
                  Om Docuit ink
                </Link>
              </li>
              <li>
                <Link to="/booking" className="hover:text-white transition-colors">
                  Booking & Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Stilarter */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-white font-bold mb-4">
              Tatoveringsstilarter
            </h4>
            <ul className="space-y-2.5 text-xs">
              {tattooStyles.map((style) => (
                <li key={style.id}>
                  <Link to={`/galleri?stil=${style.id}`} className="hover:text-white transition-colors">
                    {style.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Kontakt & Firmainfo */}
          <div>
            <h4 className="text-xs font-mono uppercase tracking-widest text-white font-bold mb-4">
              Kontakt & Adresse
            </h4>
            <ul className="space-y-3 text-xs">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#cbb05e] mt-0.5" aria-hidden="true" />
                <span>{siteSettings.fullAddress}</span>
              </li>

              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#cbb05e]" aria-hidden="true" />
                <a
                  href={`tel:${siteSettings.phoneRaw}`}
                  className="hover:text-[#cbb05e] transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{siteSettings.phone}</span>
                </a>
              </li>

              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#cbb05e]" aria-hidden="true" />
                <a
                  href={`mailto:${siteSettings.email}`}
                  className="hover:text-[#cbb05e] transition-colors whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{siteSettings.email}</span>
                </a>
              </li>

              <li className="flex items-center gap-3 text-neutral-400 font-mono text-[11px]">
                <i className="fa-solid fa-id-card text-neutral-500" aria-hidden="true" />
                <span>CVR: {siteSettings.cvr}</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom copyright line */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-neutral-500 gap-4">
          <p>© {currentYear} {siteSettings.name}. Alle rettigheder forbeholdes.</p>
          <p className="font-mono text-[11px]">{siteSettings.fullAddress}</p>
        </div>
      </div>
    </footer>
  )
}
